export default __webpack_public_path__ + "static/media/chi23-584-f.ab2fda07.pdf";